/**
     * @desc 提交反馈
仅会产生统一错误码
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/feedback', params, 'POST'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest('/api/bs-vmeeting/v3/feedback', params, swrOptions, {
    method: 'POST',
  });
}

export function request(
  params: Params,
  body: defs.client.SubmitTheFeedbackParametersOfMeeting,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/feedback', params, 'POST'),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
